/**
 * Riva — footer column headings
 *
 * The theme renders every footer column heading as a <p> carrying role="button",
 * aria-haspopup and aria-expanded, but only wires the accordion up below the
 * mobile breakpoint. Above it the columns are permanently open, so a screen
 * reader announces "Shop, button, collapsed" on something that is not a button,
 * cannot collapse, and — being a <p> with no tabindex — cannot even be reached
 * by keyboard.
 *
 * So: strip the button semantics at desktop widths, put them back below the
 * breakpoint where they are true. Purely an attribute change; the theme's own
 * accordion behaviour is untouched.
 *
 * Attributes are stashed on the element before removal rather than assumed, so
 * whatever the theme rendered is what gets restored.
 */
(function () {
  'use strict';

  // Matches the theme's own footer accordion breakpoint (max-width: 767px).
  var MOBILE_MAX = 767;
  var ATTRS = [
    ['role', 'rivaRole'],
    ['aria-haspopup', 'rivaHaspopup'],
    ['aria-expanded', 'rivaExpanded'],
  ];

  function heads() {
    return document.querySelectorAll('.footer .footer__accordion__head.js');
  }

  function apply() {
    var asButton = window.innerWidth <= MOBILE_MAX;

    Array.prototype.forEach.call(heads(), function (el) {
      ATTRS.forEach(function (pair) {
        var attr = pair[0];
        var key = pair[1];

        if (asButton) {
          // Only restore what is missing. The accordion keeps aria-expanded in
          // step with the open state, and overwriting it would fight that.
          if (!el.hasAttribute(attr) && el.dataset[key] !== undefined) {
            el.setAttribute(attr, el.dataset[key]);
          }
        } else if (el.hasAttribute(attr)) {
          el.dataset[key] = el.getAttribute(attr);
          el.removeAttribute(attr);
        }
      });
    });
  }

  var timer = null;
  function onResize() {
    clearTimeout(timer);
    timer = setTimeout(apply, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }

  window.addEventListener('resize', onResize);

  // The theme editor re-renders the footer on every settings change.
  document.addEventListener('shopify:section:load', apply);
})();
